import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { Logo } from "@/components/Logo";

export default function PaymentSuccess() {
  const { t } = useT();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("fail"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") return setState("ok");
        if (data.status === "expired") return setState("fail");
      } catch { /* retry */ }
      if (++tries < 8) setTimeout(poll, 2000); else setState("fail");
    };
    poll();
  }, [params]);
  return (
    <div className="mo-grid-bg flex min-h-screen flex-col items-center justify-center gap-6 p-6 text-center">
      <Logo />
      <h1 data-testid="payment-result" className="font-heading text-3xl font-extrabold">{state === "checking" ? t("payment_check") : state === "ok" ? t("payment_ok") : t("payment_fail")}</h1>
      <Link to="/app/subscription" data-testid="back-app-link" className="rounded-full bg-[#5aa469] px-6 py-3 font-semibold text-white">{t("back_app")}</Link>
    </div>
  );
}
